import { LocationStrategy } from '@angular/common';
import { Component, ViewContainerRef } from '@angular/core';
import { RouteGuardService } from './services/route-guard.service';
// import {NotificationService} from './services/notifications/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private readonly translate: TranslateService,
    private readonly location: LocationStrategy,
    private readonly guard: RouteGuardService,
    // public notificationService: NotificationService,
    public vcRef: ViewContainerRef // Container Rendering || DO NOT REMOVE!!!
  ) {
    const defaultLang = this.resolveDefaultLang();
    this.translate.setDefaultLang(defaultLang);
    this.translate.defaultLang = defaultLang;
    this.location.onPopState(() => {
      this.guard.setBackClicked(true);
      return false;
    });
  }

  resolveDefaultLang(): string {
    let userLang = navigator.language.split('-')[0];
    userLang = /(de|en)/gi.test(userLang) ? userLang : 'en';
    return userLang;
  }
}
